import { Injectable } from '@angular/core';
import {
  CanActivate,
  Router,
  ActivatedRouteSnapshot,
  RouterStateSnapshot
} from '@angular/router';
import { AuthService } from '../services/auth.service';

/**
 * Guard que fuerza el cambio de contraseña cuando el backend lo indica
 *
 * @remarks
 * Comportamiento:
 * - Si passwordChangeRequired === true: solo permite acceso a /auth/change-password-required
 * - Si passwordChangeRequired === false: permite navegación normal
 * - Aplica a todas las rutas bajo AdminLayoutComponent
 *
 * @example
 * ```typescript
 * {
 *   path: 'personas',
 *   canActivate: [AuthRoleGuard, ForcePasswordChangeGuard],
 *   loadChildren: () => import('./modules/personas/personas.module')
 * }
 * ```
 */
@Injectable({ providedIn: 'root' })
export class ForcePasswordChangeGuard implements CanActivate {
  private readonly FORCE_CHANGE_PASSWORD_ROUTE = '/auth/change-password-required';

  constructor(
    private readonly router: Router,
    private readonly authService: AuthService
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    // Si el usuario requiere cambio de contraseña forzado
    if (this.authService.isPasswordChangeRequired()) {
      // Si intenta acceder a la ruta de cambio forzado, permitir
      if (state.url === this.FORCE_CHANGE_PASSWORD_ROUTE) {
        return true;
      }

      // Redirigir obligatoriamente a la vista de cambio de contraseña
      this.router.navigate([this.FORCE_CHANGE_PASSWORD_ROUTE], {
        queryParams: { returnUrl: state.url }
      });

      return false;
    }

    // Si no requiere cambio de contraseña, permitir navegación normal
    return true;
  }
}
